// extracted by mini-css-extract-plugin
export default {"content":"CancelVrpModal_content__Dc0q1 zb-modal-body","subHeading":"CancelVrpModal_subHeading__F02Rd","modalFooter":"CancelVrpModal_modalFooter__2oBxY"};